import { Injectable } from '@angular/core';
import { Department } from '@interfaces/Department';
import { EstimateSettingsService } from '@shared/services/estimate-settings.service';
import { EstimateService } from '@shared/services/estimate.service';
import { UserService } from '@shared/services/user.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DepartmentPickerService {
  private departments$: Promise<Department[]>;

  public constructor(
    private userService: UserService,
    private estimateSettingsService: EstimateSettingsService,
    private estimateService: EstimateService
  ) {}

  public getDepartments() {
    if (!this.departments$) {
      this.departments$ = this._getDepartments();
    }

    return this.departments$;
  }

  private async _getDepartments() {
    const user = await this.userService.getUserAsync();
    const settings = await this.estimateSettingsService.getEstimateConfigurationAsync();

    const departments = await lastValueFrom(
      this.estimateService.getDepartments(user, this.estimateSettingsService.getRestrictedCompanies(settings))
    );

    return departments;
  }

  public async getDepartmentByCode(code: string) {
    const deptartments = await this.getDepartments();

    return deptartments.find(d => d.code === code);
  }
}
